import { getFormattedValue } from '../../../../../../../features/formatters'
import {
  PROFILE_PHOTO,
  PROFILE_NAME,
  POST_DESCRIPTION,
  FILE_URL,
  FILE_TYPE,
  MEDIA_ITEMS
} from '../../../../../../../features/components/FacebookPreviews/InstagramPostPreview/fields'

export const getFormattedInstagramSocialPostData = (post = {}, facebookPageData = {}) => {
  const isCarouselPost = post.children?.data?.length

  return {
    ...post,
    impressions: getFormattedValue({ value: post.impressions }),
    reach: getFormattedValue({ value: post.reach }),
    frequency: getFormattedValue({
      value: post.impressions / post.reach,
      type: 'frequency'
    }),
    likeCount: getFormattedValue({ value: post['like_count'] }),
    engagement: getFormattedValue({ value: post.engagement }),
    videoViews: getFormattedValue({ value: post['post_video_views'] }),
    // preview transformation
    [PROFILE_PHOTO]: facebookPageData.thumbnail,
    [PROFILE_NAME]: facebookPageData.name,
    [POST_DESCRIPTION]: post.caption,
    [MEDIA_ITEMS]: isCarouselPost
      ? post.children?.data.map(mediaItem => ({
          [FILE_URL]: mediaItem['media_url'],
          [FILE_TYPE]: mediaItem['media_type']?.toLowerCase() || 'image'
        }))
      : [
          {
            [FILE_URL]: post['media_url'],
            [FILE_TYPE]: post['media_type']?.toLowerCase() || 'image'
          }
        ]
  }
}
